export default __webpack_public_path__ + "static/media/59.96c81ad3.jpeg";